<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-4/5 w-full">
          <vs-row>
            <h2 style="font-size: revert; font-weight: 500">
              {{ bookingProduct.name }}
            </h2>
          </vs-row>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Product id</span>
          <br />
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <code>{{ bookingProduct.id }} </code>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Product name</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input v-model="bookingProduct.name"></vs-input>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Product description</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-textarea v-model="bookingProduct.description"></vs-textarea>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Price</span>
          <br />
          <small>Leave before price empty for no visible disccount</small>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input-number
            v-model="bookingProduct.price"
            :min="0"
            label="Price now"
            class="justify-start bg-transparent"
          ></vs-input-number>
          <vs-input-number
            v-model="bookingProduct.beforePrice"
            :min="0"
            label="Price before"
            class="justify-start bg-transparent"
          ></vs-input-number>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Image</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input v-model="bookingProduct.imageUrl" class="w-full mb-3"></vs-input>
          <div v-if="bookingProduct.imageUrl">
            <img :src="bookingProduct.imageUrl" class="max-w-sm rounded" />
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Last updated</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <span
            >{{ bookingProduct.updatedAction.timestamp | formatDate }} by
            {{ bookingProduct.updatedAction.userDisplayName }}</span
          >
        </div>
      </div>
    </vx-card>

    <!-- Save & Remove Button -->
    <vs-row vs-justify="space-between" class="flex flex-wrap items-center mt-5">
      <vs-button @click="onClickSave" v-if="hasPermission('vp.crm.bookingproducts.edit')">Save</vs-button>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  async created() {
    const productId = this.$route.params.id;
    await this.$store.dispatch("bookingProducts/get", productId);
    console.log("Working on bookingProduct", this.bookingForm);
  },
  methods: {
    async onClickSave() {
      try {
        this.$vs.loading();
        console.log("Saving booking product", this.bookingProduct);
        await this.$store.dispatch("bookingProducts/update", this.bookingProduct);
        this.$vs.notify({
          color: "success",
          title: "Updated",
          text: "Succesfully updated",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Could not update",
          text: err,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  computed: {
    ...mapGetters({
      bookingProduct: "bookingProducts/bookingProduct",
      isLoading: "bookingProducts/isLoading",
    }),
  },
};
</script>